<template>
  <div ref="decoratedField"/>
</template>

<script>
export default {
  name: 'ExpandedItemWrapper',
  props: {
    expandFn: null,
    item: null
  },
  mounted() {
    let element = this.expandFn(this.item);
    element.$mount();
    this.$refs.decoratedField.appendChild(element.$el);
  }
}
</script>